// extracted by mini-css-extract-plugin
export var desktop = "styles-module--desktop--f33cf";
export var mobile = "styles-module--mobile--fe4a5";